import { Component, input } from '@angular/core';
import { LineInputs } from '@charts';
import { LineChartComponent } from "../line-chart";

@Component({
  selector: 'ui-vtn-temperature-chart',
  imports: [LineChartComponent],
  template: ` <ui-line-chart [lineInputs]="lineInputs()" /> `,
})
export class VtnTemperatureChartComponent {
  lineInputs = input.required<LineInputs>();
}
